// src/pages/sakshamshg/SakshamSHGHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

export default function SakshamSHGHome() {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("empowerment");
  const [openItem, setOpenItem] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalMessage, setModalMessage] = useState("");

  const topSakshamSHGProducts = [
    "Handmade Papads & Snacks",
    "Traditional Pickles (Achar)",
    "Organic Spices & Masalas",
    "Handloom Sarees & Fabrics",
    "Natural Jaggery & Gur",
    "Millet-Based Health Foods",
    "Herbal Soaps & Cosmetics",
    "Bamboo Handicrafts",
    "Organic Honey & Bee Products",
    "Khadi Apparel & Accessories",
  ];

  const openModal = (title, message) => {
    setModalTitle(title);
    setModalMessage(message);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/sheearns");
  };

  const handleSectionClick = (id) => {
    setActiveSection(id);
    setOpenItem(null);
  };

  const handleItemClick = (item) => {
    if (item.id === "sakshamshg-guidance") {
      openModal("SakshamSHG Guidance", getModalMessageForProduct(item.label));
      setOpenItem(null);
    } else {
      setOpenItem((prev) => (prev && prev.id === item.id ? null : item));
    }
  };

  const getModalMessageForProduct = (label) => {
    if (label === "SakshamSHG Guidance") {
      return `
SakshamSHG — Brand: Vision · Mission · Values
Vision:
SakshamSHG (Viksit Bharat Abhiyan) — To light the path to a developed India by making women digitally empowered, economically independent, and socially influential across every village, town, and city.
Mission:
Enable women-led cooperatives to achieve sustainable livelihoods, meaningful enterprise, and civic leadership via a scalable digital platform (Think5Whys TaaP), capacity building, and marketplace access — thereby driving national development.
Core Values:
- Samyog (Unity) — collective strength through cooperatives.
- Atmanirbharta (Self-reliance) — local income & skill creation.
- Pragatishil (Progressive) — continuous learning and digital adoption.
- Daya & Nyaya (Compassion & Fairness) — inclusive, transparent systems.
- Sustainability — environment-friendly livelihood practices.
`;
    }
    if (label === "SakshamSHG Products") {
      return `Explore our top aggregated rural products:\n\n${topSakshamSHGProducts.map(
        (p, i) => `${i + 1}. ${p}`
      ).join("\n")}\n\nThese empower rural women through sustainable aggregation.`;
    }
    return `${label} — Detailed info coming soon for SakshamSHG's rural mission.`;
  };

  const sections = [
    {
      id: "empowerment",
      title: "Empowerment",
      emoji: "💪",
      items: [
        {
          id: "sakshamshg-guidance",
          label: "SakshamSHG Guidance",
          emoji: "🌟",
          desc: "Learn about SakshamSHG — Vision, Mission & Values",
        },
        { id: "skills", label: "Skills & Training", emoji: "🎓" },
        { id: "entre", label: "Micro-entrepreneurship", emoji: "🛍️" },
        { id: "lead", label: "Leadership", emoji: "🌟" },
      ],
    },
    {
      id: "digitization",
      title: "Digitization",
      emoji: "📲",
      items: [
        { id: "connect", label: "SakshamSHG Connect App", emoji: "🔗" },
        { id: "payments", label: "Digital Payments", emoji: "💳" },
        { id: "automation", label: "Process Automation", emoji: "🤖" },
      ],
    },
    {
      id: "finance",
      title: "Financial Inclusion",
      emoji: "💰",
      items: [
        { id: "savings", label: "Savings & Wallet", emoji: "👛" },
        { id: "credit", label: "Microcredit", emoji: "🏦" },
        { id: "insurance", label: "Micro-insurance", emoji: "🛡️" },
      ],
    },
    {
      id: "sustainability",
      title: "Sustainability",
      emoji: "🌱",
      items: [
        { id: "green", label: "Green Practices", emoji: "♻️" },
        { id: "agri", label: "Agri Value Chain", emoji: "🌾" },
        { id: "energy", label: "Clean Energy", emoji: "🔆" },
      ],
    },
    {
      id: "marketplace",
      title: "Marketplace",
      emoji: "🛒",
      items: [
        { id: "bazaar", label: "SakshamSHG Bazaar", emoji: "🏷️" },
        { id: "catalog", label: "Product Catalog", emoji: "📦" },
        { id: "orders", label: "Order Management", emoji: "📬" },
      ],
    },
    {
      id: "learning",
      title: "Learning Hub",
      emoji: "📚",
      items: [
        { id: "micro", label: "Micro-courses", emoji: "🧠" },
        { id: "mentors", label: "Mentorship", emoji: "🤝" },
        { id: "events", label: "Events & Webinars", emoji: "🎤" },
      ],
    },
    {
      id: "analytics",
      title: "Analytics",
      emoji: "📊",
      items: [
        { id: "impact", label: "Impact Dashboards", emoji: "📈" },
        { id: "insights", label: "Actionable Insights", emoji: "🔍" },
        { id: "reports", label: "Reports & KPIs", emoji: "🧾" },
      ],
    },
    {
      id: "governance",
      title: "Governance",
      emoji: "⚖️",
      items: [
        { id: "rules", label: "Co-op Rules", emoji: "📜" },
        { id: "voting", label: "Voting & Polls", emoji: "🗳️" },
        { id: "grievance", label: "Grievance Redressal", emoji: "📞" },
      ],
    },
    {
      id: "products",
      title: "Products",
      emoji: "📦",
      items: [
        { id: "sakshamshg-products", label: "SakshamSHG Products", emoji: "🛍️" },
        { id: "submission", label: "Submission Process", emoji: "📝" },
        { id: "quality", label: "Quality Policy", emoji: "✅" },
        { id: "collection", label: "Collection Center", emoji: "📍" },
        { id: "catalogue", label: "Product Catalogue", emoji: "📋" },
        { id: "certification", label: "Certification Guide", emoji: "🏆" },
      ],
    },
  ];

  const active = sections.find((s) => s.id === activeSection) || sections[0];

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100">
      {/* Header */}
      <header className="sticky top-0 z-[40] bg-[#2a0f2f] border-b border-pink-800 px-4 py-2 flex items-center justify-between shadow-lg">
        <div className="flex flex-col">
          <div className="text-xl lg:text-2xl font-bold text-pink-400">🌟 SAKSHAM SHG</div>
          <div className="text-[10px] lg:text-lg text-yellow-200">
            Women Empowerment through Micro Enterprenureship Ecosystem & Digital Transformation
          </div>
        </div>
        {/* Desktop user controls */}
        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs text-left text-pink-300">{userName}</div>
              <button
                type="button"
                onClick={handleLogout}
                className="p-2 mt-2 rounded-md bg-rose-600 hover:bg-rose-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-pink-700 text-sm text-pink-200 hover:bg-pink-900"
              >
                Login
              </button>
              <button
                type="button"
                onClick={() => navigate("/signup")}
                className="px-3 py-1 rounded-full bg-pink-500 text-white text-sm hover:bg-pink-400"
              >
                Register
              </button>
            </>
          )}
        </div>
        {/* Mobile hamburger */}
        <button
          type="button"
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-6 h-6 flex items-center justify-center text-xl text-pink-300 bg-pink-500 rounded"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>
      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-[#2a0f2f] border-b border-pink-800 px-4 py-2 z-[30] relative">
          {isLoggedIn ? (
            <div className="flex flex-row items-center justify-center gap-3">
              <span className="text-pink-300 font-medium whitespace-nowrap h-7">
                Welcome, {userName}
              </span>
              <button
                type="button"
                onClick={handleLogout}
                className="rounded-md bg-rose-600 hover:bg-rose-700 w-7 h-7 flex items-center justify-center text-white"
                title="Logout"
              >
                ⏻
              </button>
            </div>
          ) : (
            <div className="flex flex-row items-center justify-center gap-6">
              <Link to="/login" className="text-pink-300 hover:text-yellow-300">
                Login
              </Link>
              <span className="text-pink-500">|</span>
              <Link to="/signup" className="text-pink-300 hover:text-yellow-300">
                Register
              </Link>
            </div>
          )}
        </div>
      )}
      {/* Section Tabs */}
      <nav aria-label="SakshamSHG sections" className="mt-2 mb-2 relative z-[10]">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-2 place-items-center border-b border-pink-500 px-4">
          {sections.map((s) => (
            <button
              type="button"
              key={s.id}
              onClick={() => handleSectionClick(s.id)}
              className={`flex items-center gap-2 p-3 rounded-xl transition focus:outline-none focus:ring-2 focus:ring-indigo-500
                ${activeSection === s.id
                  ? "bg-indigo-600 shadow-lg"
                  : "bg-gray-800/60 hover:bg-gray-800"
                }`}
            >
              <span className="text-lg">{s.emoji}</span>
              <div className="text-left">
                <div className="text-sm font-medium">{s.title}</div>
                <div className="text-xs text-gray-300">{s.items.length} use-cases</div>
              </div>
            </button>
          ))}
        </div>
      </nav>
      {/* Active Section */}
      <section aria-live="polite" className="px-4 pb-20 relative z-[10]">
        <div className="mb-3 flex items-center justify-between">
          <h2 className="text-lg font-semibold">{active.emoji} {active.title}</h2>
          <div className="text-sm text-gray-400">Choose a use-case below</div>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
          {active.items.map((it) => (
            <div key={it.id}>
              <button
                type="button"
                onClick={() => handleItemClick(it)}
                className={`w-full flex flex-col items-start gap-2 p-3 rounded-lg transition
                  ${it.id === "sakshamshg-guidance"
                    ? "bg-gradient-to-r from-yellow-400/40 via-pink-500/30 to-purple-500/20 ring-2 ring-yellow-300 shadow-lg hover:shadow-xl"
                    : "bg-gray-800/50 hover:bg-gray-800"
                  } focus:outline-none focus:ring-2 focus:ring-indigo-400`}
                aria-expanded={openItem && openItem.id === it.id}
              >
                <div className="flex items-center gap-3 w-full">
                  <div className="text-2xl">{it.emoji}</div>
                  <div className="text-left">
                    <div className="text-sm font-medium">{it.label}</div>
                    {it.desc && <div className="text-xs text-gray-300 line-clamp-3">{it.desc}</div>}
                  </div>
                </div>
              </button>
              {openItem && openItem.id === it.id && it.id !== "sakshamshg-guidance" && (
                <div className="mt-2 p-3 rounded-md bg-gradient-to-r from-gray-800 to-gray-700 text-sm text-gray-100">
                  <div className="flex items-center justify-between mb-3">
                    <div>
                      <div className="font-semibold">{it.emoji} {it.label}</div>
                      <div className="text-xs text-gray-300 mt-1">Quick actions</div>
                    </div>
                    <div className="flex gap-2">
                      <button
                        type="button"
                        onClick={() => openModal("Open", getModalMessageForProduct(it.label))}
                        className="px-3 py-1 rounded-md bg-indigo-600/90 text-sm hover:bg-indigo-700 transition"
                      >
                        Open ➡️
                      </button>
                      <button
                        type="button"
                        onClick={() => openModal("Learn", `${it.label} — Learn`)}
                        className="px-3 py-1 rounded-md bg-gray-700/80 text-sm hover:bg-gray-600 transition"
                      >
                        Learn 📘
                      </button>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    {["✳️ Action 1", "🔎 Action 2", "🤝 Connect", "🧾 Report"].map((act) => (
                      <button
                        type="button"
                        key={act}
                        onClick={() => openModal(act, `${it.label} — ${act}`)}
                        className="p-2 rounded-md bg-gray-900/40 text-left text-sm hover:bg-gray-900/60 transition"
                      >
                        {act}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
      {/* Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-sm"
          onClick={closeModal}
        >
          <div
            className="bg-gray-800 p-6 rounded-lg max-w-md w-full mx-4 my-4 max-h-[80vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-lg font-semibold mb-4 text-pink-300">{modalTitle}</h3>
            <p className="mb-6 text-gray-300 whitespace-pre-wrap">{modalMessage}</p>
            <button
              type="button"
              onClick={closeModal}
              className="px-4 py-2 bg-pink-500 text-white rounded hover:bg-pink-600 transition w-full"
            >
              Close
            </button>
          </div>
        </div>
      )}
      {/* Footer */}
      <footer className="mt-auto bg-[#2a0f2f] border-t border-pink-800 text-pink-300 py-4 z-[20] relative">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm">
            © 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-pink-400 transition">
              About
            </Link>
            <Link to="/privacy-policy" className="text-white hover:text-pink-400 transition">
              Privacy Policy
            </Link>
            <Link to="/terms-of-use" className="text-white hover:text-pink-400 transition">
              Terms of Use
            </Link>
            <Link to="/contact-us" className="text-white hover:text-pink-400 transition">
              Contact
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}